import React, { useLayoutEffect, useRef, useState } from 'react';

export const formatPayrollNumber = (value) => {
  if (value === '' || value == null) return '';
  const [integer, decimal] = String(value).split('.');
  return `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${decimal == null ? '' : `,${decimal}`}`;
};

// Keep comma, trailing zeroes and the caret while typing. Values passed to the
// API stay numbers; the dots belong only to the Danish display format.
export default function PayrollNumberInput({ value, onValueChange, allowNegative = true, ...props }) {
  const [draft, setDraft] = useState(() => formatPayrollNumber(value));
  const input = useRef(null);
  const caret = useRef(null);
  const lastValue = useRef(value);
  useLayoutEffect(() => {
    if (value !== lastValue.current) setDraft(formatPayrollNumber(value));
    lastValue.current = value;
  }, [value]);
  useLayoutEffect(() => {
    if (caret.current != null && document.activeElement === input.current) {
      input.current.setSelectionRange(caret.current, caret.current);
      caret.current = null;
    }
  }, [draft]);
  const change = (event) => {
    const raw = event.target.value;
    const plain = raw.replace(/\./g, '').replace(/\s/g, '');
    if (!(allowNegative ? /^-?\d*(,\d{0,2})?$/ : /^\d*(,\d{0,2})?$/).test(plain)) return;
    const significantBefore = raw.slice(0, event.target.selectionStart).replace(/[.\s]/g, '').length;
    const [integer, decimal] = plain.split(',');
    const formatted = `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${decimal == null ? '' : `,${decimal}`}`;
    let position = 0; let seen = 0;
    while (position < formatted.length && seen < significantBefore) {
      if (formatted[position] !== '.') seen += 1;
      position += 1;
    }
    caret.current = position;
    setDraft(formatted);
    const parsed = Number(plain.replace(',', '.'));
    const next = !plain || plain === '-' || plain === ',' || plain === '-,' ? '' : parsed;
    lastValue.current = next;
    onValueChange(next);
  };
  return <input {...props} ref={input} type="text" inputMode="decimal" value={draft} onChange={change}
    onBlur={() => setDraft(formatPayrollNumber(value))} />;
}
